module.exports = __webpack_public_path__ + "img/p2-2.48cfc7f0.png";